// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
   1. CORE VARIABLES & RESET (Minimalist Palette)
   ------------------------------------------------------------------ */
:root {
    --landing-bg-color: #f4f4f5;         /* Light grey, low stress */
    --landing-card-bg: #ffffff;          /* Pure white */
    --landing-text-main: #18181b;        /* Dark Charcoal */
    --landing-text-muted: #71717a;       /* Muted grey */
    --landing-accent: #2563eb;           /* Solid Architectural Blue */
    --landing-border: #e4e4e7;           /* Subtle border */
    --landing-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    --landing-font-stack: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* Scoped to landing-page-wrapper to avoid polluting global app styles */
.landing-page-wrapper {
    font-family: var(--landing-font-stack);
    background-color: var(--landing-bg-color);
    color: var(--landing-text-main);
    overflow: hidden; /* Prevent scroll, app-like feel */
    height: 100vh;
    width: 100vw;
    position: relative;
    margin: 0;
    padding: 0;
}

.landing-page-wrapper * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

/* ------------------------------------------------------------------
   2. LAYOUT & Z-INDEXING
   ------------------------------------------------------------------ */
#canvas-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
}

#ui-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none; /* Let clicks pass through to canvas where empty */
    display: flex;
    flex-direction: column;
}

/* ------------------------------------------------------------------
   3. NAVIGATION
   ------------------------------------------------------------------ */
.landing-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2rem 4rem;
    pointer-events: auto;
}

.landing-logo {
    font-size: 1.25rem;
    font-weight: 700;
    letter-spacing: -0.025em;
    color: var(--landing-text-main);
    display: flex;
    align-items: center;
    gap: 10px;
}

.logo-square {
    width: 20px;
    height: 20px;
    background: var(--landing-accent);
}

.landing-nav-links button {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 0.9rem;
    margin-left: 2rem;
    color: var(--landing-text-main);
    transition: color 0.2s;
}

.landing-nav-links button:hover {
    color: var(--landing-accent);
}

.landing-btn-primary {
    background-color: var(--landing-text-main);
    color: white !important;
    padding: 0.6rem 1.2rem;
    border-radius: 4px;
    cursor: pointer;
    border: none;
    font-size: 0.9rem;
    transition: background-color 0.2s;
}

.landing-btn-primary:hover {
    background-color: var(--landing-accent);
}

/* ------------------------------------------------------------------
   4. CONTENT SECTIONS (Hero & Forms)
   ------------------------------------------------------------------ */
.landing-content-wrapper {
    flex: 1 1;
    display: flex;
    align-items: center;
    padding: 0 4rem;
    position: relative;
}

/* Hero Text Section */
.hero-section {
    width: 40%;
    pointer-events: auto;
    transition: opacity 0.5s ease, transform 0.5s ease;
}

.hero-section h1 {
    font-size: 3.5rem;
    line-height: 1.1;
    margin-bottom: 1.5rem;
    font-weight: 800;
    letter-spacing: -0.05em;
    color: var(--landing-text-main);
}

.hero-section p {
    font-size: 1.1rem;
    color: var(--landing-text-muted);
    line-height: 1.6;
    margin-bottom: 2rem;
    max-width: 90%;
}

/* Auth Card Section (Hidden by default) */
.auth-section {
    position: absolute;
    right: 4rem; /* Aligned right */
    top: 50%;
    transform: translateY(-50%) translateX(50px);
    width: 400px;
    background: var(--landing-card-bg);
    padding: 2.5rem;
    border: 1px solid var(--landing-border);
    opacity: 0;
    pointer-events: none; /* Not clickable when hidden */
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: var(--landing-shadow);
}

.auth-section.active {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
    pointer-events: auto;
}

.auth-header {
    margin-bottom: 2rem;
}

.auth-header h2 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    color: var(--landing-text-main);
}

.auth-header p {
    color: var(--landing-text-muted);
    font-size: 0.9rem;
}

/* Form Styling */
.landing-form-group {
    margin-bottom: 1.25rem;
}

.landing-label {
    display: block;
    font-size: 0.85rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: var(--landing-text-main);
}

.landing-input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid var(--landing-border);
    border-radius: 4px;
    font-size: 1rem;
    outline: none;
    transition: border-color 0.2s;
    background: #fafafa;
    color: var(--landing-text-main);
}

.landing-input:focus {
    border-color: var(--landing-accent);
    background: white;
}

.landing-submit-btn {
    width: 100%;
    padding: 0.85rem;
    background: var(--landing-accent);
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.landing-submit-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.switch-auth {
    margin-top: 1.5rem;
    text-align: center;
    font-size: 0.9rem;
    color: var(--landing-text-muted);
}

.switch-auth span {
    color: var(--landing-accent);
    cursor: pointer;
    font-weight: 600;
}

/* Utility classes for state management */
.hidden-left {
    opacity: 0;
    transform: translateX(-50px);
    pointer-events: none;
}

.error-message {
    color: #ef4444;
    font-size: 0.85rem;
    margin-top: 0.5rem;
}

.alert-error {
    background-color: #fef2f2;
    color: #991b1b;
    padding: 0.75rem;
    border-radius: 4px;
    margin-bottom: 1rem;
    font-size: 0.9rem;
    border: 1px solid #fecaca;
}

.loading-spinner-small {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top: 2px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-right: 8px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Responsive */
@media (max-width: 768px) {
    .landing-nav {
        padding: 1.5rem 2rem;
    }
    
    .landing-content-wrapper {
        padding: 0 2rem;
        flex-direction: column;
        justify-content: center;
    }
    
    .hero-section {
        width: 100%;
        text-align: center;
    }
    
    .hero-section h1 {
        font-size: 2.5rem;
    }
    
    .auth-section {
        position: relative;
        right: auto;
        top: auto;
        transform: none !important;
        width: 100%;
        max-width: 400px;
        margin-top: 2rem;
    }
    
    .auth-section.active {
        transform: none !important;
    }
    
    .hidden-left {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/LandingPage.css"],"names":[],"mappings":"AAAA;;uEAEuE;AACvE;IACI,2BAA2B,UAAU,2BAA2B;IAChE,0BAA0B,WAAW,eAAe;IACpD,4BAA4B,SAAS,kBAAkB;IACvD,6BAA6B,QAAQ,eAAe;IACpD,yBAAyB,YAAY,6BAA6B;IAClE,yBAAyB,YAAY,kBAAkB;IACvD,mDAAmD;IACnD,gGAAgG;AACpG;;AAEA,wEAAwE;AACxE;IACI,sCAAsC;IACtC,yCAAyC;IACzC,+BAA+B;IAC/B,gBAAgB,EAAE,kCAAkC;IACpD,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;;uEAEuE;AACvE;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB,EAAE,kDAAkD;IACxE,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;uEAEuE;AACvE;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0CAA0C;IAC1C,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;uEAEuE;AACvE;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,UAAU;IACV,oBAAoB;IACpB,kDAAkD;AACtD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,0CAA0C;AAC1C;IACI,kBAAkB;IAClB,WAAW,EAAE,kBAAkB;IAC/B,QAAQ;IACR,4CAA4C;IAC5C,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,uCAAuC;IACvC,UAAU;IACV,oBAAoB,EAAE,8BAA8B;IACpD,kDAAkD;IAClD,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA,iBAAiB;AACjB;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;AACpB;;AAEA,yCAAyC;AACzC;IACI,UAAU;IACV,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,2BAA2B;IAC3B,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,eAAe;AACf;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,0BAA0B;QAC1B,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* ------------------------------------------------------------------\n   1. CORE VARIABLES & RESET (Minimalist Palette)\n   ------------------------------------------------------------------ */\n:root {\n    --landing-bg-color: #f4f4f5;         /* Light grey, low stress */\n    --landing-card-bg: #ffffff;          /* Pure white */\n    --landing-text-main: #18181b;        /* Dark Charcoal */\n    --landing-text-muted: #71717a;       /* Muted grey */\n    --landing-accent: #2563eb;           /* Solid Architectural Blue */\n    --landing-border: #e4e4e7;           /* Subtle border */\n    --landing-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n    --landing-font-stack: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n/* Scoped to landing-page-wrapper to avoid polluting global app styles */\n.landing-page-wrapper {\n    font-family: var(--landing-font-stack);\n    background-color: var(--landing-bg-color);\n    color: var(--landing-text-main);\n    overflow: hidden; /* Prevent scroll, app-like feel */\n    height: 100vh;\n    width: 100vw;\n    position: relative;\n    margin: 0;\n    padding: 0;\n}\n\n.landing-page-wrapper * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\n/* ------------------------------------------------------------------\n   2. LAYOUT & Z-INDEXING\n   ------------------------------------------------------------------ */\n#canvas-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 0;\n}\n\n#ui-layer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    pointer-events: none; /* Let clicks pass through to canvas where empty */\n    display: flex;\n    flex-direction: column;\n}\n\n/* ------------------------------------------------------------------\n   3. NAVIGATION\n   ------------------------------------------------------------------ */\n.landing-nav {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 2rem 4rem;\n    pointer-events: auto;\n}\n\n.landing-logo {\n    font-size: 1.25rem;\n    font-weight: 700;\n    letter-spacing: -0.025em;\n    color: var(--landing-text-main);\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.logo-square {\n    width: 20px;\n    height: 20px;\n    background: var(--landing-accent);\n}\n\n.landing-nav-links button {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    font-size: 0.9rem;\n    margin-left: 2rem;\n    color: var(--landing-text-main);\n    transition: color 0.2s;\n}\n\n.landing-nav-links button:hover {\n    color: var(--landing-accent);\n}\n\n.landing-btn-primary {\n    background-color: var(--landing-text-main);\n    color: white !important;\n    padding: 0.6rem 1.2rem;\n    border-radius: 4px;\n    cursor: pointer;\n    border: none;\n    font-size: 0.9rem;\n    transition: background-color 0.2s;\n}\n\n.landing-btn-primary:hover {\n    background-color: var(--landing-accent);\n}\n\n/* ------------------------------------------------------------------\n   4. CONTENT SECTIONS (Hero & Forms)\n   ------------------------------------------------------------------ */\n.landing-content-wrapper {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    padding: 0 4rem;\n    position: relative;\n}\n\n/* Hero Text Section */\n.hero-section {\n    width: 40%;\n    pointer-events: auto;\n    transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n.hero-section h1 {\n    font-size: 3.5rem;\n    line-height: 1.1;\n    margin-bottom: 1.5rem;\n    font-weight: 800;\n    letter-spacing: -0.05em;\n    color: var(--landing-text-main);\n}\n\n.hero-section p {\n    font-size: 1.1rem;\n    color: var(--landing-text-muted);\n    line-height: 1.6;\n    margin-bottom: 2rem;\n    max-width: 90%;\n}\n\n/* Auth Card Section (Hidden by default) */\n.auth-section {\n    position: absolute;\n    right: 4rem; /* Aligned right */\n    top: 50%;\n    transform: translateY(-50%) translateX(50px);\n    width: 400px;\n    background: var(--landing-card-bg);\n    padding: 2.5rem;\n    border: 1px solid var(--landing-border);\n    opacity: 0;\n    pointer-events: none; /* Not clickable when hidden */\n    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: var(--landing-shadow);\n}\n\n.auth-section.active {\n    opacity: 1;\n    transform: translateY(-50%) translateX(0);\n    pointer-events: auto;\n}\n\n.auth-header {\n    margin-bottom: 2rem;\n}\n\n.auth-header h2 {\n    font-size: 1.5rem;\n    margin-bottom: 0.5rem;\n    color: var(--landing-text-main);\n}\n\n.auth-header p {\n    color: var(--landing-text-muted);\n    font-size: 0.9rem;\n}\n\n/* Form Styling */\n.landing-form-group {\n    margin-bottom: 1.25rem;\n}\n\n.landing-label {\n    display: block;\n    font-size: 0.85rem;\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n    color: var(--landing-text-main);\n}\n\n.landing-input {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid var(--landing-border);\n    border-radius: 4px;\n    font-size: 1rem;\n    outline: none;\n    transition: border-color 0.2s;\n    background: #fafafa;\n    color: var(--landing-text-main);\n}\n\n.landing-input:focus {\n    border-color: var(--landing-accent);\n    background: white;\n}\n\n.landing-submit-btn {\n    width: 100%;\n    padding: 0.85rem;\n    background: var(--landing-accent);\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    margin-top: 1rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.landing-submit-btn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.switch-auth {\n    margin-top: 1.5rem;\n    text-align: center;\n    font-size: 0.9rem;\n    color: var(--landing-text-muted);\n}\n\n.switch-auth span {\n    color: var(--landing-accent);\n    cursor: pointer;\n    font-weight: 600;\n}\n\n/* Utility classes for state management */\n.hidden-left {\n    opacity: 0;\n    transform: translateX(-50px);\n    pointer-events: none;\n}\n\n.error-message {\n    color: #ef4444;\n    font-size: 0.85rem;\n    margin-top: 0.5rem;\n}\n\n.alert-error {\n    background-color: #fef2f2;\n    color: #991b1b;\n    padding: 0.75rem;\n    border-radius: 4px;\n    margin-bottom: 1rem;\n    font-size: 0.9rem;\n    border: 1px solid #fecaca;\n}\n\n.loading-spinner-small {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top: 2px solid white;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-right: 8px;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .landing-nav {\n        padding: 1.5rem 2rem;\n    }\n    \n    .landing-content-wrapper {\n        padding: 0 2rem;\n        flex-direction: column;\n        justify-content: center;\n    }\n    \n    .hero-section {\n        width: 100%;\n        text-align: center;\n    }\n    \n    .hero-section h1 {\n        font-size: 2.5rem;\n    }\n    \n    .auth-section {\n        position: relative;\n        right: auto;\n        top: auto;\n        transform: none !important;\n        width: 100%;\n        max-width: 400px;\n        margin-top: 2rem;\n    }\n    \n    .auth-section.active {\n        transform: none !important;\n    }\n    \n    .hidden-left {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
